import { TYPE_TEXT } from '@/utils/case-types';

export default class StoryText {
  constructor(data) {
    this.text = null;
    this.type = TYPE_TEXT;
    // Initialize data
    if (data) {
      Object.assign(this, {
        text: data.Text
      });
    }
  }
}



// WEBPACK FOOTER //
// src/entities/case/case-story-items/story-text.js